/** One chunk loader per `?page=` value — shared by the lazy routes and by the
 *  entry-time preload, so a deep link fetches its page chunk in parallel with
 *  auth boot instead of after it. */
export const PAGE_LOADERS = {
  "ventura-port": () => import("pages/Ventura/UpdatedVentura"),
  "eu-ets-report": () => import("pages/euEtsReport/EuEtsReport"),
  token: () => import("pages/token/Token"),
  seasonality: () => import("pages/seasonality/SeasonalityPage"),
  "ffa-overview": () => import("pages/ffaOverview/FFAOverviewPage"),
  "sea-margin": () => import("pages/seaMargin/SeaMarginPage"),
  "emission-report": () => import("pages/emissionReport/EmissionReportPage"),
  "file-sharing": () => import("pages/fileSharing/FileSharingPage"),
  "weather-in-ports": () => import("pages/weatherInPorts/WeatherInPortsPage"),
  "team-estimates": () => import("pages/teamEstimates/TeamEstimatesPage"),
  "vessel-view": () => import("pages/vesselView/VesselViewPage"),
  "business-card": () => import("pages/businessCard/BusinessCardPage"),
  directory: () => import("pages/directory/DirectoryPage"),
  "fdtr-strategies": () => import("pages/fdtrStrategies/FdtrStrategiesPage"),
  "recap-manager": () => import("pages/trades/TradesPage"),
  dataloy: () => import("pages/dataloy/DataloyPage"),
  "cargo-plan": () => import("pages/cargoPlan/CargoPlanPage"),
  "cargo-orders": () => import("pages/cargoList/CargoListPage"),
  signals: () => import("pages/signals/SignalsPage"),
  "navilex-v2": () => import("pages/navilexV2/NavilexV2Page"),
  options: () => import("pages/options/OptionsPage"),
  defaultContent: () => import("pages/landing/LandingPage"),
} as const;

export type LazyPage = keyof typeof PAGE_LOADERS;

/** Kick off the chunk fetch for `page`; an unknown page falls through to the landing chunk. */
export function preloadPage(page: string): void {
  const load =
    (PAGE_LOADERS as Record<string, () => Promise<unknown>>)[page] ??
    PAGE_LOADERS.defaultContent;
  void load().catch(() => undefined);
}
